import { BING_TRACKING_KEY } from '@/types/BingTracking';
import { FACEBOOK_TRACKING_KEY } from '@/types/FacebookTracking';
import { GOOGLE_TRACKING_KEY } from '@/types/GoogleTracking';
import { OURS_DEVICE_ID_KEY } from '@/types/OursDeviceId';
import { SUBMISSION_URL_KEY } from '@/types/salesforce';
import { SALESFORCE_TRACKING_KEYS } from '@/types/SalesforceTracking';
import { UTM_KEYS } from '@/types/UrchinTrackingModule';
import { VISUAL_WEBSITE_OPTIMIZER_KEY } from '@/types/VisualWebsiteOptimizer';
import { useMemo } from 'react';

export const MARKETING_COOKIE_KEYS = [
  ...UTM_KEYS,
  GOOGLE_TRACKING_KEY,
  BING_TRACKING_KEY,
  OURS_DEVICE_ID_KEY,
  VISUAL_WEBSITE_OPTIMIZER_KEY,
  SUBMISSION_URL_KEY,
  FACEBOOK_TRACKING_KEY,
  ...SALESFORCE_TRACKING_KEYS,
] as const;

type MarketingCookieKey = (typeof MARKETING_COOKIE_KEYS)[number];

export type MarketingCookies = Record<
  MarketingCookieKey,
  string | undefined | boolean
>;

const useCookies = () => {
  const cookies = useMemo(() => {
    if (typeof document === 'undefined') return [];

    const cookieList = document.cookie.split(';');

    return cookieList
      .map(item => {
        const [name, value] = item.split('=');

        if (!name) return;

        return { name: name.trim(), value: value?.trim() };
      })
      .filter(item => item !== undefined);
  }, []);

  return cookies;
};

export const useMarketingCookies = () => {
  const allCookies = useCookies();

  const marketingCookies = useMemo(() => {
    const marketingCookiesObject: MarketingCookies = {};

    allCookies.forEach(({ name, value }) => {
      if (!name) return;

      if (MARKETING_COOKIE_KEYS.includes(name)) {
        marketingCookiesObject[name] = value;
      }
    });

    return marketingCookiesObject;
  }, [allCookies]);

  return { marketingCookies };
};
